module.exports = __webpack_public_path__ + "img/cam-plus-photos.43453c77.svg";